"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileIcon = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const HslColor_1 = require("../../styles/color/HslColor");
const context_1 = require("../../styles/context");
const color_1 = require("../../styles/color");
const colors_1 = require("./colors");
const LITE_TEXT = new color_1.LinearRgbColor(1, 1, 1, 0.7);
const DARK_TEXT = new color_1.LinearRgbColor(0, 0, 0, 0.7);
exports.FileIcon = React.memo(({ label, id, ext, color = ext ? (0, colors_1.getColor)(ext) : undefined, size = 16, gradient, accent, link, ...rest }) => {
    const id1 = React.useId();
    const id2 = React.useId();
    const styles = (0, context_1.useStyles)();
    const effectiveId = id || label;
    const primaryColor = color
        ? (HslColor_1.HslColor.from(color) ?? HslColor_1.HslColor.fromHash(effectiveId))
        : HslColor_1.HslColor.fromHash(effectiveId);
    const gradientColor = gradient === true
        ? primaryColor.gradientPair()
        : typeof gradient === 'string'
            ? (HslColor_1.HslColor.from(gradient) ?? primaryColor.gradientPair())
            : null;
    const accentColor = accent === true
        ? primaryColor.accentColor()
        : typeof accent === 'string'
            ? (HslColor_1.HslColor.from(accent) ?? primaryColor.complement())
            : primaryColor.copy(0.1, 0, -0.1);
    const h = size;
    const w = Math.round(size * 0.8);
    const viewW = 100;
    const viewH = 125;
    const f = 28; // fold size
    const r = 7; // corner radius
    const bodyPath = `M ${r},0 L ${viewW - f},0 L ${viewW},${f} L ${viewW},${viewH - r} Q ${viewW},${viewH} ${viewW - r},${viewH} L ${r},${viewH} Q 0,${viewH} 0,${viewH - r} L 0,${r} Q 0,0 ${r},0 Z`;
    const gradId = `fi-g-${id1}`;
    const clipId = `fi-c-${id2}`;
    const primaryStr = primaryColor.toString();
    const gradientStr = gradientColor?.toString() ?? primaryStr;
    const displayLabel = (label || '').slice(0, size < 21 ? 2 : size < 25 ? 3 : 4).toUpperCase();
    return (React.createElement("svg", { width: w, height: h, viewBox: `0 0 ${viewW} ${viewH}`, ...rest, "aria-label": label ? `${label} file` : 'file', role: "img" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: gradId, x1: "0%", y1: "0%", x2: "100%", y2: "100%" },
                React.createElement("stop", { offset: "0%", stopColor: primaryStr }),
                React.createElement("stop", { offset: "100%", stopColor: gradientStr })),
            React.createElement("clipPath", { id: clipId },
                React.createElement("path", { d: bodyPath }))),
        React.createElement("path", { d: bodyPath, fill: `url(#${gradId})` }),
        React.createElement("rect", { x: "0", y: viewH - Math.round(viewH * 0.18), width: viewW, height: Math.round(viewH * 0.09), fill: "rgba(255,255,255,0.18)", clipPath: `url(#${clipId})` }),
        React.createElement("rect", { x: "0", y: viewH - Math.round(viewH * 0.09), width: viewW, height: Math.round(viewH * 0.09), fill: "rgba(0,0,0,0.18)", clipPath: `url(#${clipId})` }),
        React.createElement("polygon", { points: `${viewW - f},0 ${viewW},${f} ${viewW - f},${f}`, fill: accentColor.toString(), opacity: "0.72" }),
        React.createElement("line", { x1: viewW - f, y1: 0, x2: viewW - f, y2: f, stroke: "rgba(255,255,255,0.4)", strokeWidth: "1.5" }),
        link && (React.createElement("g", { clipPath: `url(#${clipId})` },
            React.createElement("circle", { cx: 78, cy: 103, r: 34, fill: "white", stroke: "rgba(0,0,0,0.2)", strokeWidth: 3 }),
            React.createElement("circle", { cx: 78, cy: 103, r: 20, fill: accentColor.toString() }))),
        displayLabel && (React.createElement("text", { x: viewW / 2, y: viewH * 0.56, textAnchor: "middle", dominantBaseline: "middle", fill: primaryColor.toLinearRgb().pickFirstAboveOrMax(2, [LITE_TEXT, DARK_TEXT]) + '', 
            // fontSize={displayLabel.length * -2 + 40 + (size < 24 && displayLabel.length < 3 ? 4 : 0)}
            fontSize: displayLabel.length * -2 + 40 + (size < 25 ? 26 - displayLabel.length * 4 : 0), fontFamily: styles.txt.get('mono', 'bold', 0).ff + ",'SF Mono', 'Fira Code', 'Cascadia Code', ui-monospace, monospace", fontWeight: "700", letterSpacing: displayLabel.length >= 4 ? '-1' : '0' }, displayLabel))));
});
